import React, { SyntheticEvent, useEffect, useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import TextField from '@mui/material/TextField';
import { Link } from 'react-router-dom';
import { MdVerified } from 'react-icons/md';
import swal from 'sweetalert';
import { Alert, Grid, Pagination } from '@mui/material';
import { petsitterType } from '../../Types/PetSitterTypes';
import { PerfilTypesToken } from '../../Types/PerfilTypes';
import RegisterPetsitterForm from '../Petsitters/registerPetsitterForm';
import Footer from '../Footer';
import Navbar from '../Navbar';
import RegionesYcomunas from '../RegisterForm/regionesComunas';
import SelectableFilterList from '../Common/selectableFilterList';
import serviceImg from '../../Assets/Imagenes/blank-service-picture.png';
import './indexPetsitters.css';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import AnnouncementIcon from '@mui/icons-material/LightbulbOutlined';

function mapStateToProps(state: any) {
  return { action: state };
}

function PetsittersShowAll(props: PerfilTypesToken) {
  const petsittersInPage: number = 10;
  const regionsNames = Object.values(RegionesYcomunas.regiones).map((region) => region.NombreRegion);
  const [registerPetsitter, setRegisterPetsitter] = useState<boolean>(false);
  const [petsitters, setPetsitters] = useState<Array<petsitterType>>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [comunasOptions, setComunasOptions] = useState<Array<string>>([]);
  const [checkedFilter, setCheckedFilter] = useState<{
    region: string[];
    comunas: string[];
  }>({
    region: [],
    comunas: []
  });
  const [nameFilter, setNameFilter] = useState<string>('');
  const [isPetsitter, setIsPetsitter] = useState<boolean>(false);

  function toggleRegisterPetsitter(event: SyntheticEvent) {
    event.preventDefault();
    setRegisterPetsitter(!registerPetsitter);
  }

  function closePetsitterOpenRegister(event: SyntheticEvent) {
    event.preventDefault();
    setRegisterPetsitter(false);
  }

  function closePetsitterOpenLogIn(event: SyntheticEvent) {
    event.preventDefault();
    setRegisterPetsitter(false);
  }

  function togglePetsitterRegister(event: SyntheticEvent) {
    event.preventDefault();
    setRegisterPetsitter(!registerPetsitter);
  }

  useEffect(() => {
    fetchPetsitters(currentPage);
  }, [currentPage, checkedFilter, nameFilter]);

  async function fetchPetsitters(page: number) {
    const token = JSON.parse(localStorage.getItem('token') || '');
    const queryParams = new URLSearchParams();
    queryParams.append('page', page.toString());
    queryParams.append('limit', petsittersInPage.toString());

    const addFilterParam = (filterArray: string[], paramName: string) => {
      const joinedFilter = filterArray.join(',');
      if (joinedFilter) {
        queryParams.append(paramName, joinedFilter);
      }
    };
    addFilterParam(checkedFilter.region, 'region');
    addFilterParam(checkedFilter.comunas, 'comuna');
    if (nameFilter) {
      queryParams.append('name', nameFilter);
    }

    const url = `${process.env.REACT_APP_URL}/petsitters?${queryParams.toString()}`;
    await axios.get(url, { headers: { Authorization: 'Bearer ' + token } })
      .then((response) => {
        setPetsitters(response.data.petsitters);
        setTotalPages(response.data.pagination.totalPages);
      });

    await axios.get(process.env.REACT_APP_URL + `/petsitters/${props.action.user.credenciales.id}`, { headers: { Authorization: 'Bearer ' + token } })
      .then((response) => {
        if (response.data.petsitter.IsPetsitter[0] === undefined) {
          setIsPetsitter(false);
        } else {
          setIsPetsitter(true);
        }
      });
  }

  async function preDeletePetsitter(id: string) {
    swal({
      title: 'Alerta',
      text: '¿Estás seguro que quieres eliminar este servicio?',
      icon: 'warning',
      buttons: ['Cancelar', true],
      dangerMode: true
    })
      .then((willDelete) => {
        if (willDelete) {
          deletePetsitter(id);
        }
      });
  }

  async function deletePetsitter(id: string) {
    const token = JSON.parse(localStorage.getItem('token') || '');
    await axios.delete(process.env.REACT_APP_URL + `/petsitters/${id}`, { headers: { Authorization: 'Bearer ' + token } })
      .then(() => {
        swal({
          title: 'Se eliminó el servicio',
          icon: 'success',
          timer: 2000
        });
        fetchPetsitters(currentPage);
      });
  }

  const handleToggle = (
    listName: 'region' | 'comunas',
    value: string
  ) => () => {
    const currentIndex = checkedFilter[listName].indexOf(value);
    const newChecked = [...checkedFilter[listName]];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setCheckedFilter((prev) => ({ ...prev, [listName]: newChecked }));
    if (listName === 'region') {
      const selectedRegion = RegionesYcomunas.regiones.find(region => region.NombreRegion === value);
      setComunasOptions((prev) => {
        if (currentIndex === -1 && selectedRegion) {
          prev.push(...selectedRegion.comunas);
          return prev.sort();
        } else {
          const newCommunesFiltered = prev.filter(
            (com) => !selectedRegion?.comunas.includes(com)
          );
          return newCommunesFiltered.sort();
        }
      });
    }
  };

  const isAdmin = props.action.user.credenciales.rol === 5;

  return (
    <>
      <div>
        <Navbar logged={true} />
        <Grid container spacing={2} style={{ padding: '20px' }}>
          {/* Filters Section */}
          <Grid item xs={12} md={3} lg={3}>
            <div className='filters-container'>
              <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={12} style={{ marginTop: 20 }}>
                  {(!isPetsitter && !isAdmin) && (
                    <Alert icon={<AnnouncementIcon fontSize="inherit" />} severity="info" style={{ marginBottom: '20px' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <span style={{ marginBottom: '10px' }}>
                          ¿Quieres ser petsitter?
                        </span>
                        <button className="register-vet-button" onClick={(e) => toggleRegisterPetsitter(e)}>Únete</button>
                      </div>
                    </Alert>
                  )}
                </Grid>
              </Grid>
              <h6 className='navigation-info-post-post pt-3 ms-3'>Petsitters</h6>

              {/* Name Filter */}
              <div className='category-container'>
                <div className='category-title'>
                  <h2>Nombre</h2>
                </div>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Nombre"
                  variant="outlined"
                  value={nameFilter}
                  onChange={e => setNameFilter(e.target.value)}
                />
              </div>

              {/* Region Filter */}
              <div className='category-container'>
                <div className='category-title'>
                  <h2>Región</h2>
                </div>
                <SelectableFilterList
                  items={regionsNames}
                  checked={checkedFilter.region}
                  handleToggle={(value) => handleToggle('region', value)}
                />
              </div>

              {/* Comuna Filter */}
              <div className='category-container'>
                <div className='category-title'>
                  <h2>Comuna</h2>
                </div>
                <SelectableFilterList
                  items={comunasOptions}
                  checked={checkedFilter.comunas}
                  handleToggle={(value) => handleToggle('comunas', value)}
                />
              </div>
            </div>
          </Grid>

          {/* Petsitters Grid */}
          <Grid item xs={12} md={9} lg={9}>
            {petsitters.length > 0 ? (
              <>
                {/* Pagination */}
                <div className="pagination-container">
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={(event, value) => setCurrentPage(value)}
                    color="secondary"
                    size="large"
                    sx={{
                      '& .MuiPaginationItem-root': {
                        color: 'gray',
                        '&.Mui-selected': {
                          backgroundColor: '#287685',
                          color: 'white'
                        },
                        '&.Mui-selected:hover': {
                          backgroundColor: '#287685'
                        },
                        '&:hover': {
                          backgroundColor: 'lightblue'
                        }
                      }
                    }}
                  />
                </div>

                {/* Petsitters Cards */}
                <div className='card-group'>
                  {petsitters.map((service) => (
                    <div key={service.id} className="card card-vet">
                      <img
                        src={service.profileUrlImg || serviceImg}
                        className="img-card-vet"
                        alt={`${service.petsitterName} logo`}
                      />
                      <div className="card-body">
                        {service.verified_status === 'verified' ? (
                          <h5 className="card-title comuna-vet">
                            {service.petsitterName}
                            <MdVerified style={{ fill: '#C75100' }} title='Petsitter verificado por Vepet'/>
                          </h5>
                        ) : (
                          <h5 className="card-title">{service.petsitterName}</h5>
                        )}
                        <p className="card-text comuna-vet">
                          {service.petsitterAddressComuna}, {service.petsitterAddressRegion}
                        </p>
                      </div>
                      {props.action.user.credenciales.rol === 5 && (
                        <button
                          className="profile-button-red"
                          onClick={() => preDeletePetsitter(service.id)}
                        >
                          Eliminar cuenta
                        </button>
                      )}
                      <Link to={{ pathname: '/petsitters/' + service.id }}>
                        <button className="profile-button">Ver su perfil</button>
                      </Link>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <Grid container justifyContent={'center'} alignItems={'baseline'}>
                <Alert icon={<WarningAmberOutlinedIcon fontSize="inherit" />} severity="info">
                  No hay petsitters registrados
                </Alert>
              </Grid>
            )}
          </Grid>
        </Grid>
      </div>

      {/* Register Petsitter Modal */}
      {registerPetsitter && (
        <div className="register-form-container">
          <div className="register-form-content">
            <RegisterPetsitterForm
              closePetsitterOpenRegister={closePetsitterOpenRegister}
              closePetsitterOpenLogIn={closePetsitterOpenLogIn}
              togglePetsitterRegister={togglePetsitterRegister}
              toggleSignUpUser={closePetsitterOpenRegister}
            />
          </div>
        </div>
      )}
      <Footer />
    </>
  );
}

export default connect(mapStateToProps)(PetsittersShowAll);
